// Libs
import classNames from 'classnames/bind';
import { Heading, View } from '@instructure/ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
// Components, Layouts, Pages
// Others
import { adminRoute } from '~/utils/routes/admin';
// Styles, images, icons
import styles from './Dashboard.module.scss';

const cx = classNames.bind(styles);

const Dashboard = () => {
  //#region Destructuring Props
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/dashboard']);
  const navigate = useNavigate();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleNavigateTuitionArea = () => {
    navigate(`${adminRoute.base}${adminRoute.tuitionArea}`);
  };

  const handleNavigateAdministrativeArea = () => {
    navigate(`${adminRoute.base}${adminRoute.administrativeArea}`);
  };
  //#endregion Handle Function

  return (
    <div className={cx('container')}>
      <Heading level='h3' margin='0 0 small 0'>
        {t('dashboard_admin_title')}
      </Heading>

      <Heading level='h4' margin='large 0 small 0'>
        {t('dashboard_admin_area_title')}
      </Heading>

      <View as='div' className={cx('content')}>
        <View as='div' className={cx('section')} onClick={handleNavigateTuitionArea}>
          <Heading level='h4'>{t('dashboard_admin_tuition_button')}</Heading>
        </View>

        <View as='div' className={cx('section')} onClick={handleNavigateAdministrativeArea}>
          <Heading level='h4'>{t('dashboard_admin_exam_button')}</Heading>
        </View>
      </View>
    </div>
  );
};

export default Dashboard;
